import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import ahoy from 'ahoy.js'

ahoy.configure({
  urlPrefix: '',
  visitsUrl: '/ahoy/visits',
  eventsUrl: '/ahoy/events',
  visitDuration: 30, // minutes
  withCredentials: false,
  visitParams: {},
  page: null,
  useBeacon: true,
})

export default function usePageTracking() {
  const location = useLocation()

  useEffect(() => {
    ahoy.trackView({ url: window.location.pathname })
  }, [location.pathname])
}
